import './App.scss';
import {useEffect, useState} from "react"
import * as Pusher from "pusher-js";
import Pond from './Pond';

import Lobby from './Lobby';

function App() {

  const[lobbyStatus, setLobbyStatus] = useState(returnLobbyFromUrl); // if lobbyStatus == null, that means it hasn't joined or created
  const[channel, setChannel] = useState(null);

  // Runs the first time the component mounts onto the page


  // runs on page load, checks if user is loading in to lobby or to room
  function returnLobbyFromUrl(){
    

    let lobbyCodeParam = new URLSearchParams(window.location.search);
    
    if (lobbyCodeParam.toString() != ""){ //if entering with a valid code
        console.log(lobbyCodeParam.toString());
        return lobbyCodeParam.get("pond");
    } else {
        return -1;
    }

  }


  return (
    <div className="App">
      {/* display main menu */}
      {lobbyStatus === -1 
        ? <Lobby />
        : <>
            {/* run script that joins the server, and display server information */}
            {console.log("this should only print once")}
            <Pond ID={lobbyStatus}/>
          </>
      }
    </div>
  );
}

export default App;
